const baseStyle = {
  borderRadius: 'md',
};

const defaultProps = {
  variant: 'ghost',
  size: 'md',
};

const sizes = {
  lg: {
    px: 3,
    py: 3,
  },
  md: {
    px: 2,
    py: 2,
  },
  sm: {
    px: 1,
    py: 1,
  },
};

export default {
  baseStyle,
  sizes,
  defaultProps,
};
